<script>
  import http from '@/service/http'
  import { ListSelect } from 'vue-search-select'
  import {mapState} from 'vuex'

  export default {
    name: 'Form',
    components: {
      ListSelect
    },
    data () {
      return {
        usuarios: [{}],
        produtos: [],
        viatura: {
          id: '',
          viatura: '',
          envolvidos: [],
          produtos: []
        },
        item: {
          id: '',
          produto: '',
          valor: '',
          qtd: ''
        }
      }
    },
    mounted () {
      this.fecth()
    },
    watch: {
      '$route' () {
        if (this.$route.params.id != null) {
          this.fecth()
        }
      },
      hasAll () {
        if (this.hasAll) {
          this.all = true
        } else {
          this.all = false
        }
      }
    },
    methods: {
      validate () {
        this.$validator.validateAll().then(success => {
          if (!success) {
            this.$swal({
              title: 'Ops, encontramos um erro!',
              html: 'Um ou mais campos estão com seu preenchimento incorreto',
              type: 'error',
              cancelButtonText: 'Ok'
            })
            return false
          } else {
            this.submit()
          }
        })
      },
      async submit () {
        const verb = this.isNew ? 'post' : 'put'
        const url = this.isNew ? '/viaturas' : `/viaturas/${this.viatura.id}`
        const {data} = await http[verb](url, this.viatura)
        if (data != null) {
          this.$emit('update-viaturas-list', {viatura: data.viatura})
          this.$router.push({name: 'viaturas.index'})
        }
      },
      async fecth () {
        this.clear()
        const {id} = this.$route.params
        if (id !== undefined) {
          const {data} = await http.get(`/viaturas/${id}/edit`)
          this.viatura = data.viatura
          this.usuarios = data.usuarios
          this.produtos = data.produtos
        } else {
          const {data} = await http.get(`/viaturas/create`)
          this.usuarios = data.usuarios
          this.produtos = data.produtos
        }
        setTimeout(function () {
          window.Materialize.updateTextFields()
        }, 0)
      },
      clear () {
        this.viatura = {
          id: '',
          viatura: '',
          envolvidos: [],
          produtos: []
        }
      },
      onSelectProduto (item) {
        if (item) {
          const produto = {
            produto_id: item.id,
            produto: item,
            qtd: 1
          }
          this.addProduto(produto)
        }
      },
      async addProduto (produto) {
        if (typeof this.viatura.produtos === 'undefined') {
          this.viatura.produtos = []
        }
        await this.viatura.produtos.push(produto)
        setTimeout(function () {
          window.Materialize.updateTextFields()
        }, 0)
      },
      destroyProduto (indexProduto) {
        this.$swal({
          title: 'Atenção',
          text: `excluir um Produto é uma operação irreversível e vai restabelecer estoques`,
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          cancelButtonColor: '#d33',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Sim, quero excluir!',
          reverseButtons: true
        }).then(() => {
          if (!this.viatura.produtos[indexProduto].id) {
            this.viatura.produtos.splice(indexProduto, 1)
            window.Materialize.toast('Produto excluído!', 4000)
          } else {
            http.delete(`viaturas/produto/${this.viatura.produtos[indexProduto].id}`)
              .then(response => response.data)
              .then(data => {
                window.Materialize.toast('Produto excluído!', 4000)
                this.viatura.produtos.splice(indexProduto, 1)
              })
          }
        })
      }
    },
    computed: {
      ...mapState(['loading']),
      isNew () {
        return this.viatura.id === ''
      },
      api_url () {
        return process.env.UPLOADS_URL
      },
      viaturaEnvolvidos: {
        get () {
          return this.usuarios.filter(
            option => this.viatura.envolvidos.includes(option.id)
          )
        },
        set (newSelectedOptions) {
          this.viatura.envolvidos = newSelectedOptions.map(option => option.id)
        }
      }
    }
  }
</script>

<template>
  <div>

    <form @submit.prevent="validate">

      <div class="row">

        <div class="col s12 m10 offset-m1">

          <div class="row">
            <div class="input-field col s12 m5">
              <input name="viatura" id="viatura" type="text" v-validate
                     data-vv-rules="required" :class="{invalid: errors.has('viatura')}"
                     v-model="viatura.viatura">
              <label for="viatura">*Viatura</label>
              <small class="red-text">{{ errors.first('viatura') }}</small>
            </div>

            <div class="col s12 m7">
              <label>Usuários Envolvidos</label>
              <multiselect multiple placeholder="Selecione" :closeOnSelect="false" v-model="viaturaEnvolvidos" label="nome_completo" track-by="id"  :options="usuarios"></multiselect>
            </div>

          </div>

          <div class="row">

              <div class="row">
                <div class="input-field col s12">
                  <list-select :list="produtos"
                               option-value="id"
                               option-text="produto"
                               :selected-item="item"
                               placeholder="Adicionar Produto"
                               @select="onSelectProduto">
                  </list-select>
                </div>
              </div>

              <div class="row" v-show="viatura.produtos && viatura.produtos.length > 0">
                <div class="col s12">
                  <table class="responsive-table bordered highlight">
                    <tr>
                      <th>Materiais Utilizados</th>
                      <th>Qtd</th>
                      <th class="right-align">Excluir</th>
                    </tr>
                    <tr v-for="(produto, indexProduto) in viatura.produtos">
                      <td>
                        <p>{{ (produto.produto) ? produto.produto.produto : '-' }}</p>
                      </td>
                      <td>
                        <input type="number" :id="`qtdProduto${indexProduto}`" v-model="produto.qtd" min="1"
                               style="margin-bottom: 0" :readonly="produto.hasOwnProperty('id')">
                      </td>
                      <td>
                        <div class="right-align">
                          <a href="#" @click.prevent="destroyProduto(indexProduto)">
                            <i class="material-icons red-text">delete_forever</i>
                          </a>
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>

          </div>

          <div class="row">

            <div class="input-field col s12">
              <button class="waves-effect waves-light btn" :disabled="loading">Salvar</button>
            </div>

          </div>

        </div>

      </div>

    </form>

  </div>
</template>



// WEBPACK FOOTER //
// src/features/viaturas/form.vue